function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M14.816 0H1.18A1.168 1.168 0 000 1.153v13.692A1.169 1.169 0 001.181 16h13.635A1.171 1.171 0 0016 14.845V1.153A1.17 1.17 0 0014.816 0zM4.746 13.634H2.371V5.998h2.373v7.636zm-1.187-8.68a1.376 1.376 0 11-.001-2.751 1.376 1.376 0 01.001 2.752zm10.075 8.68h-2.372V9.921c0-.886-.016-2.025-1.233-2.025-1.235 0-1.424.965-1.424 1.96v3.778H6.234V5.998H8.51v1.044h.032a2.493 2.493 0 012.245-1.234c2.403 0 2.847 1.582 2.847 3.638v4.188z",
  id: "linkedin_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "linkedin_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#linkedin_svg__a"
})), React.createElement("use", {
  fill: "currentColor",
  fillRule: "nonzero",
  xlinkHref: "#linkedin_svg__a"
}), React.createElement("g", {
  mask: "url(#linkedin_svg__b)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M-2-4h20v20H-2z"
})));

var Linkedin = function Linkedin(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default Linkedin;